// extracted by mini-css-extract-plugin
export var fileUpload = "_g0-1";
export var modalButton = "_g0-0";